import React from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from 'react-router-dom';

import { Header } from './components/Header/Header';
import { Pages } from './views/Pages';
import { Page } from './views/Page';
import { Components } from './views/Components';
import { Component } from './views/Component';
import { Tags } from './views/Tags';
import { Tag } from './views/Tag';
import { Asset } from './views/Asset';
import { Category } from './views/Category';
import { Container } from './components/Container/Container';
import { Editors } from './views/Editors';
import { Editor } from './views/Editor';
import { Users } from './views/Users';
import { User } from './views/User';
import { PromotionPictures } from './views/PromotionPictures';
import { Assets } from './views/Assets';
import { ErrorBoundary } from './components/ErrorBoundary/ErrorBoundary';

import type { ReactNode } from 'react';

import styles from './Router.module.scss';

function RouteErrorBoundary({ children }: { children: ReactNode }) {
  const location = useLocation();
  return <ErrorBoundary key={location.pathname}>{children}</ErrorBoundary>;
}

function Router() {
  return (
    <BrowserRouter>
      <Header />
      <Container className={styles.container}>
        <RouteErrorBoundary>
          <Routes>
            <Route path="/login" element={<Navigate to="/pages" replace />} />
            <Route path="/pages/:pageId" element={<Page />} />
            <Route path="/pages" element={<Pages />} />
            <Route path="/components/:componentId" element={<Component />} />
            <Route path="/components" element={<Components />} />
            <Route path="/tags/:tagId" element={<Tag />} />
            <Route path="/tags" element={<Tags />} />
            <Route path="/assets/:assetId/edit" element={<Asset />} />
            <Route path="/assets/:kind" element={<Assets />} />
            <Route path="/assets" element={<Assets />} />
            <Route path="/categories/:categoryId" element={<Category />} />
            <Route path="/categories" element={<Category />} />
            <Route path="/editors/:editorId" element={<Editor />} />
            <Route path="/editors" element={<Editors />} />
            <Route path="/users/:userId" element={<User />} />
            <Route path="/users" element={<Users />} />
            <Route path="/pictures" element={<PromotionPictures />} />
            <Route path="/" element={<Navigate to="/pages" replace />} />
          </Routes>
        </RouteErrorBoundary>
      </Container>
    </BrowserRouter>
  );
}

export { Router };
